import { z } from 'zod';

import { ForbearanceBasePlan } from '../loan/WorkoutPlan';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreateWorkoutPlanForbearanceEvent = BaseLoanEvent.extend({
  type: z.literal('createWorkoutPlanForbearance'),
  data: ForbearanceBasePlan.pick({
    subType: true,
    programMoratoriumStartDate: true,
    startDate: true,
    originalTermMonths: true,
    drawsAllowed: true,
    imminentDefault: true,
    workflowInformation: true,
  }).extend({
    forbearanceType: z.enum(['suspended', 'reduced']),
    reducedPaymentAmount: z.number().nonnegative(),
  }),
});
export type CreateWorkoutPlanForbearanceEvent = z.infer<typeof CreateWorkoutPlanForbearanceEvent>;
